//@flow
import { useRef, useEffect } from "react";
import type ProductModel from '../Stores/Products/productModel';
import type { ReviewSummaryData, ReviewSummaryObject } from '../Stores/Products/reviewSummaryModel';

export const usePrevious = (value:any) => {
  const ref = useRef();
  useEffect(() => {
    ref.current = value;
  });
  return ref.current;
};

export const deriveProductReviewSummary = (product:ProductModel|null, data:ReviewSummaryData):ReviewSummaryObject|null => {
  if (!product) return null;
  const sku = product.getSku();
  if (product.isPackage()) {
    // If package product has only a single child
    // product, show reviews for child product.
    // Otherwise, don't show review data for package products
    const skus = product.getPackageProductSkus();
    if (skus.length === 1) {
      const childSku = skus[0];
      return data[childSku] || null;
    } else {
      return null;
    }
  }
  else {
    return data[sku] || null;
  }
};
